module.exports = __webpack_public_path__ + "img/jupiter.f757c119.png";